module.exports = __webpack_public_path__ + "img/SchreitenderXVII.e6c636d5.jpg";